
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Punetolonavalabushire() {



    const cardData =
    {
        keyword: 'Pune to Lonavala Bus Hire',
        heading: 'Amruta Travels: Pune to Lonavala Bus Hire',
        headingDescription: 'Amruta Travels offers Pune to Lonavala Bus Hire, delivering a convenient and relaxing travel solution to one of Maharashtra’s most popular hill stations. Whether you are planning a weekend getaway, school picnic, corporate retreat, or family outing, our buses ensure a smooth and enjoyable ride to Lonavala. Choose from a range of comfortable buses including 17-seater, 32-seater, and 50-seater options, all maintained to the highest standards and operated by experienced drivers. With affordable rates, on-time service, and 24/7 customer support, Amruta Travels makes your Pune to Lonavala journey safe, scenic, and stress-free. Book your bus today and enjoy the ride!',


        top: 'Top Places to Visit in Lonavala with Amruta Travels',
"topPlaces": [
  {
    "title": "Tiger's Leap (Tiger Point)",
    "description": "A dramatic cliff-top viewpoint offering panoramic views of the valley and Western Ghats. The spot is famous for its echo point and a small seasonal waterfall during the monsoon."
  },
  {
    "title": "Bhushi Dam",
    "description": "A popular monsoon destination, Bhushi Dam is known for its overflowing steps and scenic surroundings. Visitors often enjoy wading through the water and relaxing by the dam."
  },
  {
    "title": "Lohagad Fort",
    "description": "An ancient hill fort at 1,033 meters, Lohagad offers a relatively easy trek with rewarding views. The 'Vinchukata' or 'Scorpion’s Tail' extension is a notable feature of the fort."
  },
  {
    "title": "Karla Caves",
    "description": "Dating back to the 2nd century BCE, these Buddhist rock-cut caves are renowned for the Grand Chaitya hall and intricate carvings. The site also houses the Ekvira Devi Temple."
  },
  {
    "title": "Rajmachi Fort",
    "description": "A historic fort complex comprising Shrivardhan and Manaranjan forts. It's a favored trekking destination, especially during the monsoon, offering scenic views and a glimpse into Maratha history."
  },
  {
    "title": "Pawna Lake",
    "description": "An artificial lake formed by the Pawna Dam, it's a popular spot for camping, picnics, and enjoying serene lakeside views, especially during the cooler months."
  },
  {
    "title": "Della Adventure Park",
    "description": "India’s largest adventure park, spread over 36 acres, offering over 50 activities including bungee jumping, dirt biking, and zip-lining. The park also features luxury accommodations and dining options."
  },
  {
    "title": "Bhaja Caves",
    "description": "Ancient rock-cut caves dating back to the 2nd century BCE, featuring impressive stupas and intricate carvings. The site provides insights into early Buddhist architecture."
  },
  {
    "title": "Sunil's Celebrity Wax Museum",
    "description": "A unique museum showcasing wax statues of various celebrities, including Indian and international figures, offering a fun and interactive experience for visitors."
  },
  {
    "title": "Lion's Point",
    "description": "A scenic viewpoint between Bhushi Dam and Aamby Valley, offering breathtaking views of the valley, especially during sunrise and sunset. It's a popular spot for photography and enjoying local snacks."
  }
],



  "services": [
    {
      "name": "Tempo Travellers On Rent For Lonavala in Pune",
      "description": "Amruta Travels offers Tempo Travellers on rent from Pune to Lonavala, perfect for family outings, college trips, and weekend getaways. Choose from 13 to 20-seater AC vehicles with push-back seats and ample luggage space for a comfortable ride."
    },
    {
      "name": "Pune to Lonavala Urbania Bus on Rent",
      "description": "Travel in luxury from Pune to Lonavala with our Force Urbania buses. Ideal for premium group travel, these AC mini buses offer top-tier comfort, professional drivers, and smooth bookings for leisure or business tours."
    },
    {
      "name": "Pune to Khandala Bus Hire Package",
      "description": "Book a complete bus hire package from Pune to Khandala with Amruta Travels. Our services are suitable for sightseeing, school trips, and weekend escapes, with multiple bus options to fit your group size and budget."
    },
    {
      "name": "Pune to Lonavala 17 Seater Bus Hire Package",
      "description": "Amruta Travels provides 17-seater AC buses for a convenient Pune to Lonavala trip. Ideal for small to medium groups, the package includes professional drivers, clean interiors, and scenic stopovers along the way."
    },
    {
      "name": "17 Seater Bus Rate Per Km in Pimpri Chinchwad",
      "description": "Get competitive per kilometer rates for 17-seater bus rentals in Pimpri Chinchwad with Amruta Travels. Ideal for local travel or short outstation trips like Lonavala, our transparent pricing makes group travel affordable."
    },
    {
      "name": "Pune to Lonavala Khandala Bus Tour Package",
      "description": "Explore both Lonavala and Khandala in a single-day or multi-day tour with Amruta Travels’ curated packages. Our buses are equipped for comfort and are driven by experienced chauffeurs for a smooth travel experience."
    },
    {
      "name": "Pune to Lonavala 14 17 20 25 32 Seater Bus on Rent",
      "description": "Choose from a range of mid-size buses for your trip to Lonavala. From 14 to 32 seaters, Amruta Travels offers flexible and comfortable travel solutions with AC options and personalized travel plans."
    },
    {
      "name": "Pune to Lonavala 35 40 45 50 Seater Bus On Rent",
      "description": "For larger groups, Amruta Travels provides full-size buses ranging from 35 to 50 seats. Whether for school excursions or corporate events, our spacious AC buses ensure a pleasant travel experience from Pune to Lonavala."
    },
    {
      "name": "Pune to Lonavala 2 Day Bus Package",
      "description": "Amruta Travels offers a 2-day Pune to Lonavala bus rental package perfect for extended tours, family gatherings, or group holidays. Packages include vehicle rental, driver charges, and flexible itinerary support."
    },
    {
      "name": "Pune to Khandala Mini Bus Package",
      "description": "Enjoy a peaceful getaway to Khandala with our mini bus packages. Amruta Travels offers 14 to 25-seater mini buses for short trips, ideal for small groups seeking convenience, comfort, and affordability."
    },
    {
      "name": "Pune to Lonavala Corporate Bus Package",
      "description": "For companies planning off-site retreats or team outings, Amruta Travels provides dedicated corporate bus rental packages from Pune to Lonavala. Options include AC buses, flexible departure times, and business-friendly services."
    },
    {
      "name": "Pune to Lonavala Corporate Event Package",
      "description": "Amruta Travels offers tailored bus rental solutions for corporate events in Lonavala. From transport logistics to comfortable seating and AC buses, we ensure a seamless travel experience for all event participants."
    }
  ],
  "tableData": [
    ["Tempo Travellers On Rent For Lonavala in Pune", "Pune to Lonavala Urbania Bus on Rent"],
    ["Pune to Khandala Bus Hire Package", "Pune to Lonavala 17 Seater Bus Hire Package"],
    ["17 Seater Bus Rate Per Km in Pimpri Chinchwad", "Pune to Lonavala Khandala Bus Tour Package"],
    ["Pune to Lonavala 14 17 20 25 32 Seater Bus on Rent", "Pune to Lonavala 35 40 45 50 Seater Bus On Rent"],
    ["Pune to Lonavala 2 Day Bus Package", "Pune to Khandala Mini Bus Package"],
    ["Pune to Lonavala Corporate Bus Package", "Pune to Lonavala Corporate Event Package"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Comfortable Travel from Pune to Lonavala",
    "WhyChoosedescription": "Amruta Travels offers convenient and comfortable Pune to Lonavala Bus Hire services, perfect for one-day picnics, weekend getaways, and corporate or family outings. Our buses are equipped with spacious seating, air conditioning, and clean interiors to ensure a smooth and relaxing journey through the scenic Western Ghats. Whether you're traveling with friends, family, or colleagues, we provide a reliable and enjoyable travel experience."
  },
  {
    "WhyChooseheading": "Ideal for Group Tours, School Trips, and Corporate Outings",
    "WhyChoosedescription": "Our Pune to Lonavala bus rentals are the ideal solution for group travel. Whether it's a school field trip, corporate team-building day, or a family celebration, we offer a range of bus sizes to accommodate small to large groups. With plenty of room for passengers and luggage, you can travel comfortably and conveniently with your entire group."
  },
  {
    "WhyChooseheading": "Experienced Drivers for a Safe Journey",
    "WhyChoosedescription": "Our professional and courteous drivers are experienced with the Pune to Lonavala route and prioritize passenger safety and comfort. They follow all traffic regulations and ensure on-time pickups and drop-offs, allowing you to enjoy your trip without stress. Our drivers are also knowledgeable about the best rest stops and scenic routes, enhancing your travel experience."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "We offer cost-effective and clearly priced packages for Pune to Lonavala Bus Hire. With no hidden charges, you can plan your group travel confidently. Whether you need a bus for a one-way trip, a return journey, or a full-day rental, our pricing is designed to be flexible and budget-friendly while maintaining top-quality service."
  },
  {
    "WhyChooseheading": "Clean, Well-Maintained Buses for All Group Sizes",
    "WhyChoosedescription": "Our fleet includes 17, 20, 32, 35, 40, 45, and 50-seater buses—cleaned and serviced regularly for comfort and hygiene. Whether you're traveling for a leisure trip or a business outing, you’ll find our buses clean, well-ventilated, and equipped with comfortable seating for a pleasant ride to Lonavala."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop-Off in Pune and Lonavala",
    "WhyChoosedescription": "We offer full flexibility in choosing pickup and drop-off points anywhere in Pune or Lonavala. Be it your office, school, society, or event venue, our team coordinates with you to ensure smooth boarding and return logistics. We work with your schedule to make your trip as seamless as possible."
  },
  {
    "WhyChooseheading": "Customizable Itineraries for a Tailored Experience",
    "WhyChoosedescription": "Planning to visit Bhushi Dam, Tiger’s Leap, or Lonavala Lake? We offer fully customizable travel plans to include multiple sightseeing stops and flexible halt timings. Whether you want a direct ride or a scenic route with planned breaks, our team helps create a travel experience that fits your group’s preferences."
  },
  {
    "WhyChooseheading": "Easy Booking and Full Customer Support",
    "WhyChoosedescription": "Booking your Pune to Lonavala bus is simple with Amruta Travels. Reserve online, call our support team, or visit us in person. Our dedicated team is available to help you select the right vehicle, plan your itinerary, and answer any questions you may have—ensuring a smooth and well-organized trip from start to finish."
  }
]

















    }

const faqData = [
  {
    question: 'How can I hire a bus for a trip from Pune to Lonavala?',
    answer: 'Hiring a bus from Pune to Lonavala with Amruta Travels is simple. You can book online, contact our support team, or visit our office. We’ll guide you in selecting the right bus based on your group size and preferences.',
  },
  {
    question: 'What types of buses are available for Pune to Lonavala trips?',
    answer: 'We offer a range of buses including 32, 35, 40, 45, and 50-seater options for the Pune to Lonavala route. You can choose between standard, AC, and luxury buses depending on your comfort and budget needs.',
  },
  {
    question: 'How long does it take to travel from Pune to Lonavala?',
    answer: 'The average travel time from Pune to Lonavala is around 1.5 to 2.5 hours depending on traffic and your starting point. Our drivers ensure a smooth and safe ride through the scenic route.',
  },
  {
    question: 'Is the trip suitable for day outings or weekend getaways?',
    answer: 'Yes, Pune to Lonavala is a popular route for one-day trips, weekend getaways, corporate outings, and school excursions. We can help you plan your itinerary with flexible pickup and drop-off points.',
  },
  {
    question: 'Are the buses comfortable for the Pune to Lonavala journey?',
    answer: 'Absolutely. Our buses are equipped with push-back seats, air conditioning, and ample space to ensure comfort during your short journey to Lonavala.',
  },
  {
    question: 'Can I request multiple pickup points in Pune?',
    answer: 'Yes, we offer flexible pickup and drop-off options. Share your group’s locations with us and we’ll plan a convenient route for all passengers.',
  },
  {
    question: 'How much does it cost to hire a bus from Pune to Lonavala?',
    answer: 'Pricing depends on the type of bus, number of passengers, and duration of the trip. Contact us for a detailed and competitive quote tailored to your travel plan.',
  },
  {
    question: 'Are your buses available for return trips or overnight stays in Lonavala?',
    answer: 'Yes, we offer both same-day return and overnight packages to Lonavala. Just let us know your schedule, and we’ll make the arrangements accordingly.',
  },
  {
    question: 'Why choose Amruta Travels for Pune to Lonavala bus hire?',
    answer: 'With well-maintained buses, experienced drivers, and flexible service, Amruta Travels ensures a reliable and enjoyable travel experience. We focus on safety, punctuality, and customer satisfaction.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Rohit Desai',
    role: 'Corporate Event Organizer, Pune',
    text: 'We booked a 40-seater bus from Amruta Travels for our office team outing to Lonavala. The bus was punctual, clean, and very comfortable. Everyone enjoyed the trip. Great service!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Kavita Naik',
    role: 'School Coordinator, Pune',
    text: 'Our school rented two buses for a Lonavala picnic. The kids were safe and happy, and the buses were in top condition. Drivers were polite and professional. Highly recommend Amruta Travels!',
    rating: 5,
  },
];




















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Lonavala Bus Hire",
  "image": "https://bushireinpune.com/assets/images/pune-to-lonavala-bus-hire.jpg",
  "description": "Hire buses from Pune to Lonavala and Khandala for tours, weekend getaways, and corporate trips. Choose from 14, 17, 20, 25, 32, 35, 40, 45, and 50 seater buses, Tempo Travellers, and Urbania. 1-day and 2-day bus packages available. Affordable rates per km from Pimpri-Chinchwad, Pune, and surrounding areas.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3599",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-to-lonavala-bus-hire"
  }
};




    return (
        <div>


<Helmet>
  <title>Call: +91 7353109555 | Pune to Lonavala Bus Hire | Tour & Corporate Bus Packages | Amruta Travels</title>
  <meta 
    name="description" 
    content="Book Pune to Lonavala bus hire packages. 14 to 50 seater options, Tempo Travellers & Urbania for corporate events, 1-day or 2-day tours, and weekend getaways. Affordable rates per km." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/38.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetolonavalabushire;